import React from 'react'
import './Home.css'
import tabletop from './images/home/tabletop.png'
import encyclopedia from './images/home/encyclopedia.png'
import dice from './images/home/dice.png'
import line from './images/home/line.png'
import HomeCarousel2 from '../HomeCarousel'
import Suggestion from './Suggestion'

function Home() {
  return (
    <div class="background">
      <div class="container">
        <div class="banner">
          <div className='container  d-inline'>
            <div className='homepageText'>
              <div className='row justify-content-md-center container'>
                <img src={tabletop} className="tabletop" id="tabletop"></img>
              </div>
              <div className='row container justify-content-md-center'>
                <img src={encyclopedia} className='encyclopedia' id="encyclopedia"></img>
              </div>
              <div className='row container justify-content-md-center'>
                <img src={dice} className='dice'></img>
              </div>
              <div className='row container justify-content-md-center'>
                <img src={line} className='line2'></img>
              </div>

            </div>
          </div>

        </div>
      </div>
      <HomeCarousel2 />
      {/* <Suggestion /> */}
    </div>
  )
}

export default Home
